import { BlueprintDraft } from './blueprintsTypes';

type Translate = (key: string) => string;

interface ValidateOptions {
  /** When false, skips the "at least one transaction" rule (e.g. on the metadata step of the wizard). */
  requireTransactions?: boolean;
}

export const validateBlueprintDraft = (
  draft: BlueprintDraft,
  t: Translate,
  options: ValidateOptions = {},
): string | null => {
  if (!draft.name.trim()) return t('validation.nameRequired');
  if (options.requireTransactions !== false && draft.transactionIds.length === 0) {
    return t('validation.noTransactions');
  }
  return null;
};
